<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;">
			<el-row :gutter="2">
					<el-col :span="6">
						
						<el-button type="primary" @click="freeMarketUpdate">添加市场</el-button>
						
					</el-col>
					<el-col :span="6">
						
							<el-input v-model="companyName" class="" placeholder="市场名称"></el-input>
						
					</el-col>
					<el-col :span="12">
						
						<el-button type="primary" @click="searchFreeMarket">查询</el-button>
						
					</el-col>
				</el-row>
			
		</div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="marketName" label="市场名称" width="180"></el-table-column>
      		<el-table-column prop="cityName" label="所在城市" width="150"></el-table-column>
      		<el-table-column prop="state" label="状态" width="180">
	      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
      				<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
      			</template>
      		</el-table-column>	
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==0" @click="visibleFreeMarket(scope.$index, scope.row)">置为有效</el-button>
					<el-button size="small" v-if="scope.row.state==1" @click="visibleFreeMarket(scope.$index, scope.row)">置为无效</el-button>
					<el-button size="small" @click="freeMarketUpdate(scope.$index, scope.row)">修改</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		
	</div>

	
</template>
<script >
	import {getFreeMarketList,visibleFreeMarket} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0,
		 		companyName:''
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getFreeMarketList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			searchFreeMarket(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getFreeMarketList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
				});
			},
			freeMarketUpdate(index,row){
				var param = {};
				if(row!=null){
					param.id = row.id;
				}
				this.$router.push({name:"freeMarketUpdate",query:param});
			},
			reload(){
				console.log("reload");
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,companyName:this.companyName};
				getFreeMarketList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			visibleFreeMarket(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				visibleFreeMarket(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>